import { Outlet } from '@solidjs/router';
import EnsureOnboardingNotCompleted from './EnsureOnboardingNotCompleted';
const EnsureOnboardingNotCompletedRoutes = () => (<EnsureOnboardingNotCompleted>
    <Outlet />
  </EnsureOnboardingNotCompleted>);
export default EnsureOnboardingNotCompletedRoutes;
